__turbopack_context__.v({
  "discountWrapperp": "styles-module__wP4UMW__discountWrapperp",
  "discountedFullPrice": "styles-module__wP4UMW__discountedFullPrice",
  "price": "styles-module__wP4UMW__price",
});
